export default (errorFormName) => {
  return {
    event: 'errorBooking',
    errorType: errorFormName,
  };
};
